export default "__VITE_ASSET__BTk6uVNJ__"